$(function() {
  //imgタグに矢印画像
  var prevImg = '<a href="javascript:void(0)" class="slideArrow prevArrow"><img src="https://icooon-mono.com/i/icon_12240/icon_122401_64.png"></a>',
      nextImg = '<a href="javascript:void(0)" class="slideArrow nextArrow"><img src="https://icooon-mono.com/i/icon_12241/icon_122411_64.png"></a>';

  // スライダーの開始位置を動画に設定
  var video_slide = 0;
  $('.slider3 li').each(function() {
    if($('.slider3').hasClass('invalid')) {
      return false;
    }
    if($(this).hasClass('video')) {
      video_slide = $(this).data('index');
    }
  })

  // スライダー3ここから
  var thumbnail = $('.sliderThumbnail');
  
  $('.slider3').slick({
    // appendArrows: $("#arrows3"),
    appendDots: $("#dots"),
    adaptiveHeight: true,
    initialSlide: video_slide,
    // asNavFor: thumbnail,
    // prevArrow: prevImg,
    // nextArrow: nextImg,
    dots:true
  });
  // サムネイル
  // thumbnail.slick({
  //   slidesToShow: 3,
  //   asNavFor: '.slider3',
  //   centerMode: true,
  //   centerPadding:'0%',
  // })
  // thumbnail.find('.slick-slide').on('click',function() {
  //   var index = $(this).attr('data-slick-index');
  //   thumbnail.slick('slickGoTo',index,false);
  // })
  // スライダー3ここまで

  // サムネイルクリックで移動
  $('.sliderThumbnail a').on('click',function() {
    var index = $(this).attr('data-slick-index');
    $('.slider3').slick('slickGoTo',index,false);
  })

  // 再生ボタン
  $('#video_play').on('click',function() {
    $('.video_video video').get(0).play();
  })

  // $('.video_video video').get(0).pause();

  // スライドが表示されたら自動再生
  $('.slider3').on('afterChange',function(slick) {
    var current = $(this).slick('slickCurrentSlide');
    if($(`[data-slick-index="${current}"]`).hasClass('video')) {
      $(`[data-slick-index="${current}"] video`).get(0).play();
    }
  })
})